import React, { useContext, Suspense } from 'react';
import Navigation from './Nav/Navigation';
import { Routes, Route } from 'react-router-dom';
import AuthContext from '../AuthContext';
import FloatingBookNow from './FloatingBookNow';
import useFloatingButton from './hooks/useFloatingButton';
import { Navigate } from 'react-router-dom';

// Lazy-loaded komponensek
const Home = React.lazy(() => import('./Nav/Views/Home/Home'));
const Contact = React.lazy(() => import('./Contact/Contact'));
const Weapons = React.lazy(() => import('./Nav/Views/Weapons/Weapons'));
const Packages = React.lazy(() => import('./Nav/Views/Packages/Packages'));
const AboutUs = React.lazy(() => import('./Nav/Views/LilSites/AboutUs'));
const Membership = React.lazy(() => import('./Nav/Views/LilSites/Membership'));
const Login = React.lazy(() => import('./Nav/Views/Login'));
const Admin = React.lazy(() => import('./Nav/Views/AdminPanel/Admin'));
const MembershipContacts = React.lazy(() => import('./Nav/Views/AdminPanel/MembershipContacts'));
const Settings = React.lazy(() => import('./Nav/Views/AdminPanel/Settings'));
const Booking = React.lazy(() => import('./Nav/Views/Booking'));
const EditWeapons = React.lazy(() => import('./Nav/Views/AdminPanel/EditWeapons'));
const EditPackages = React.lazy(() => import('./Nav/Views/AdminPanel/EditPackages'));
const PrivacyPolicy = React.lazy(() => import('./Nav/Views/Inform/PrivacyPolicy'));
const TermsAndConditions = React.lazy(() => import('./Nav/Views/Inform/TermsAndConditions'));
const ReturnsPolicy = React.lazy(() => import('./Nav/Views/Inform/ReturnsPolicy'));
const EditPosts = React.lazy(() => import('./Nav/Views/Post/Admin/EditPosts'));
const EditPost = React.lazy(() => import('./Nav/Views/Post/Admin/EditPost'));
const Posts = React.lazy(() => import('./Nav/Views/Post/Client/Posts'));
const Post = React.lazy(() => import('./Nav/Views/Post/Client/Post'));
const EditPartner = React.lazy(() => import('./Nav/Views/Partner/Admin/EditPartner'));
const EditPartners = React.lazy(() => import('./Nav/Views/Partner/Admin/EditPartners'));
const Partners = React.lazy(() => import('./Nav/Views/Partner/Client/Partners'));
const Partner = React.lazy(() => import('./Nav/Views/Partner/Client/Partner'));
const GiftCard = React.lazy(() => import('./Nav/Views/GiftCard/GiftCard'));
const GiftCardSuccess = React.lazy(() => import('./Nav/Views/GiftCard/GiftCardSuccess'));
const GiftCards = React.lazy(() => import('./Nav/Views/AdminPanel/GiftCards'));

function Loader(){
  return (
    <div style={{height: '100vh'}} className='d-flex justify-content-center align-items-start pt-5'>
      <div className='spinner-border text-danger' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </div>
    </div>
  );
}

export default function Public() {
  const { isLoggedIn } = useContext(AuthContext);
  const shouldShowFloatingButton = useFloatingButton(isLoggedIn);

  return (
    <div>
      <Navigation />
      {shouldShowFloatingButton && <FloatingBookNow />}
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="spr" element={<Booking />} />
          <Route exact path="/contact" element={<></>} />
          <Route exact path="/recommendations/partners" element={<Partners />} />
          <Route exact path="/recommendations/partner/:id" element={<Partner />} />
          <Route exact path="/weapons" element={<Weapons />} />
          //LEGACY WEAPONS ROUTE
          <Route exact path="/budapest-shooting-experience-weapons" element={<Navigate to="/weapons" replace />} />
          <Route exact path="/packages" element={<Packages />} />
          //LEGACY PACKAGES ROUTE
          <Route exact path="/our-packages" element={<Navigate to="/packages" replace />} />
          <Route exact path="/about-us" element={<AboutUs />} />
          <Route exact path="/membership" element={<Membership />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/gift-card" element={<GiftCard />} />
          //LEGACY GIFT CARD ROUTE
          <Route exact path="/general-6" element={<Navigate to="/gift-card" replace />} />
          <Route exact path="/booking/:id" element={<Booking />} />
          <Route exact path="/policy" element={<PrivacyPolicy />} />
          <Route exact path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route exact path="/returns-policy" element={<ReturnsPolicy />} />
          <Route exact path="/posts" element={<Posts />} />
          //LEGACY POSTS ROUTE
          <Route exact path="/blog" element={<Navigate to="/posts" replace />} />
          <Route exact path="/gift-card-success" element={<GiftCardSuccess />} />
          <Route exact path="/post/:date/:seoUrl" element={<Post />} />
          {isLoggedIn && <Route exact path="/edit/partners/:id" element={<EditPartner />} />}
          {isLoggedIn && <Route exact path="/edit/partners" element={<EditPartners />} />}
          {isLoggedIn && <Route exact path="/edit/posts/:id" element={<EditPost />} />}
          {isLoggedIn && <Route exact path="/edit/posts" element={<EditPosts />} />}
          {isLoggedIn && <Route exact path="/admin" element={<Admin />} />}
          {isLoggedIn && <Route exact path="/settings" element={<Settings />} />}
          {isLoggedIn && <Route exact path="/memberships-contacts" element={<MembershipContacts />} />}
          {isLoggedIn && <Route exact path="/edit/weapons" element={<EditWeapons />} />}
          {isLoggedIn && <Route exact path="/edit/packages" element={<EditPackages />} />}
          {isLoggedIn && <Route exact path="/gift-cards" element={<GiftCards />} />}
          <Route path="*" element={<div style={{ color: 'red', opacity: 0.8, fontSize: '4em', textAlign: 'center', marginBottom: '2em' }}>404</div>} />
        </Routes>
      </Suspense>
      {!isLoggedIn && <Suspense fallback={<Loader />}>
        <Contact />
      </Suspense>}
    </div>
  );
}